import styled from 'styled-components';

export const BoxSection = styled.div`
  padding: 32px;
  border: 1px solid #e7e7e7;
`;

export const InformationsComplementairesBox = styled.div`
  padding: 32px;
  padding-bottom: 8px;
  border: 1px solid #e7e7e7;
`;
